export const languageMessages = (language:string, key: string) => {
  const messages: any = {
    en: {
      promotionHeadline: 'Your proposal is pre-approved!',
      promotionHeadlineMain: 'Your proposal is ',
      promotionHeadlineGreen: 'pre-approved!',
      monthlyLabel: 'Monthly',
      annualLabel: 'Annual',
      premiumToBePaid: 'Premium to be paid',
      perMonth: 'per month',
      makePayment: 'Make payment',
      promotionBadge: 'Pay from the {ordinal} month 🎁',
      promotionSubtitleSingular: 'Just the payment is missing to send your <b>proposal for analysis.</b><br/>Coverage only begins after <b>final approval</b> and policy issuance.',
      promotionSubtitleSingularMobile: 'Just the payment is missing to send your <b>proposal for analysis.</b>',
      promotionSubtitlePlural: 'Just the payment is missing to send your <b>proposal for analysis.</b><br/>Coverage begins after <b>final approval</b> and policy issuance.',
      promotionSubtextBefore: 'Add your payment method and, if approved, Nomad and Olé will give you',
      promotionSubtextAfter: 'of free protection.',
      freeInstallmentsMonthSingular: 'month',
      freeInstallmentsMonthPlural: 'months',
      premiumLabel: 'Your premium will be',
      promotionMonthly: 'Monthly',
      saveCard: 'Save card',
      cardRegistrationSubtitle: 'Add your payment method.',
      brokerCardRegistrationSubtitle: 'Just the payment is missing to send your <b>proposal for analysis.</b><br/>Coverage begins after <b>final approval</b> and policy issuance.',
      titleApproved: 'Your Olé application has been approved!',
      titleRegular: 'You are one step away from requesting your Olé life insurance',
      subtitleApproved: 'Pay now to <b>activate your policy</b> and <b>protect your loved ones:</b>',
      //subtitleRegular: 'You may see temporary <b>hold of USD $1</b> during our evaluation process.',
      subtitleRegular: '',
      description: 'Your premium will be:',
      authorizePayments: ' I authorize recurring payments.',
      payNowAprroved: 'Pay now',
      payNowRegular: 'Add a debit or credit card',
      frequency: {
        M: 'Month',
        A: 'Year',
        S: 'Semester',
        Q: 'Quarter',
      },
      skip: 'Skip step',
      errorMessages: {
        payment: {
            title: 'There was a problem with your payment',
            subtitle: 'Please try a different payment method or review your card information.',
            buttonText: 'Try again'
        },
        session: {
            title: 'There was a problem getting your information',
            subtitle: 'Please try again.',
            buttonText: 'Try again'
        },
        existsSession: {
            title: 'Thank you!',
            subtitle: 'Your request has already been sent.',
            buttonText: ''
        }
      },
    },
    es: {
      promotionHeadline: '¡Su propuesta está pre-aprobada!',
      promotionHeadlineMain: 'Su propuesta está ',
      promotionHeadlineGreen: '¡pre-aprobada!',
      monthlyLabel: 'Mensual',
      annualLabel: 'Anual',
      premiumToBePaid: 'Prima a pagar',
      perMonth: 'por mes',
      makePayment: 'Realizar pago',
      promotionBadge: 'Paga desde el {ordinal} mes 🎁',
      promotionSubtitleSingular: 'Falta solo el pago para enviar tu <b>propuesta para análisis.</b><br/>La cobertura solo comienza después de la <b>aprobación final</b> y emisión de la póliza.',
      promotionSubtitleSingularMobile: 'Falta solo el pago para enviar tu <b>propuesta para análisis.</b>',
      promotionSubtitlePlural: 'Falta solo el pago para enviar tu <b>propuesta para análisis.</b><br/>La cobertura comienza después de la <b>aprobación final</b> y emisión de la póliza.',
      promotionSubtextBefore: 'Agregue su método de pago y, si es aprobado, Nomad y Olé le darán',
      promotionSubtextAfter: 'de protección gratis.',
      freeInstallmentsMonthSingular: 'mes',
      freeInstallmentsMonthPlural: 'meses',
      premiumLabel: 'Su prima será',
      promotionMonthly: 'Mensual',
      saveCard: 'Guardar tarjeta',
      cardRegistrationSubtitle: 'Agregue su método de pago.',
      brokerCardRegistrationSubtitle: 'Solo falta el pago para enviar tu <b>propuesta para análisis.</b><br/>La cobertura comienza después de la <b>aprobación final</b> y emisión de la póliza.',
      titleApproved: '¡Tu solicitud de Olé ha sido aprobada!',
      titleRegular: 'Estás a un paso de solicitar tu seguro de vida Olé',
      subtitleApproved: 'Paga ahora para <b>activar tu póliza</b> y <b>proteger a tus seres queridos.</b>',
      //subtitleRegular: 'Es posible que vea <b>una retención temporal de USD $1</b> durante nuestro proceso de evaluación.',
      subtitleRegular: '',
      description: 'Su prima será:',
      authorizePayments: 'Autorizo pagos recurrentes',
      payNowAprroved: 'Pagar ahora',
      payNowRegular: 'Agregar tarjeta de débito o crédito',
      frequency: {
        M: 'Mes',
        A: 'Año',
        S: 'Semestre',
        Q: 'Trimestre',
      },
      skip: 'Omitir paso',
      errorMessages: {
        payment: {
            title: 'Hubo un problema con tu pago',
            subtitle: 'Por favor, intenta con un método de pago diferente o revisa la información de tu tarjeta.',
            buttonText: 'Intentar de nuevo'
        },
        session: {
            title: 'Hubo un problema al obtener tu información',
            subtitle: 'Por favor, inténtalo de nuevo.',
            buttonText: 'Intentar de nuevo'
        },
        existsSession: {
            title: '¡Gracias!',
            subtitle: 'Tu solicitud ya ha sido enviada con éxito.',
            buttonText: ''
        }
      },
    },
    pt: {
      promotionHeadline: 'Sua proposta está pré-aprovada!',
      promotionHeadlineMain: 'Sua proposta está ',
      promotionHeadlineGreen: 'pré-aprovada!',
      monthlyLabel: 'Mensal',
      annualLabel: 'Anual',
      premiumToBePaid: 'Prêmio a ser pago',
      perMonth: 'por mês',
      makePayment: 'Realizar Pagamento',
      promotionBadge: 'Pague a partir do {ordinal} mês 🎁',
      promotionSubtitleSingular: 'Falta só o pagamento para enviar sua <b>proposta para análise.</b><br/>A cobertura só começa após a <b>aprovação final</b> e emissão da apólice.',
      promotionSubtitleSingularMobile: 'Falta só o pagamento para <b>enviar sua proposta para análise.</b>',
      promotionSubtitlePlural: 'Falta apenas o pagamento para enviar sua <b>proposta para análise.</b><br/>A cobertura começa após a <b>aprovação final</b> e emissão da apólice.',
      promotionSubtextBefore: 'Adicione seu método de pagamento e, se aprovado, Nomad e Olé te dão',
      promotionSubtextAfter: 'de proteção grátis.',
      freeInstallmentsMonthSingular: 'mês',
      freeInstallmentsMonthPlural: 'meses',
      premiumLabel: 'O seu prêmio será',
      promotionMonthly: 'Mensal',
      saveCard: 'Salvar cartão',
      cardRegistrationSubtitle: 'Adicione seu método de pagamento.',
      brokerCardRegistrationSubtitle: 'Falta apenas o pagamento para enviar sua <b>proposta para análise.</b><br/>A cobertura começa após a <b>aprovação final</b> e emissão da apólice.',
      titleApproved: 'Sua solicitação de Olé foi aprovada!',
      titleRegular: 'Você está a um passo de solicitar seu seguro de vida Olé',
      subtitleApproved: 'Estamos quase lá. <b>Pague agora para enviar sua proposta para análise.</b>',
      //subtitleRegular: 'Você pode ver <b>uma retenção temporária de USD $1</b> durante nosso processo de avaliação.',
      subtitleRegular: '',
      description: 'Seu prêmio será:',
      authorizePayments: 'Autorização de pagamentos recorrentes',
      payNowAprroved: 'Pague agora',
      payNowRegular: 'Adicionar cartão de débito ou crédito',
      frequency: {
        M: 'Mês',
        A: 'Ano',
        S: 'Semestre',
        Q: 'Trimestre',
      },
      skip: 'Pular etapa',
      errorMessages: {
        payment: {
            title: 'Houve um problema com seu pagamento',
            subtitle: 'Por favor, tente um método de pagamento diferente ou revise as informações do seu cartão.',
            buttonText: 'Tentar novamente'
        },
        session: {
            title: 'Houve um problema ao obter suas informações',
            subtitle: 'Por favor, tente novamente.',
            buttonText: 'Tentar novamente'
        },
        existsSession: {
            title: 'Obrigado',
            subtitle: 'Sua solicitação já foi enviada.',
            buttonText: ''
        }
      },
    },
  }
  return messages[language][key];
};